/* ======================================================================
   ScrubMe – variant media filter + mobile dots
   - Base URL: keeps the main product hero visible
   - Variant URL / variant selected: shows selected variant hero first
   - Variant URL / variant selected: hides the base product hero from the carousel
   - Variant URL / variant selected: hides media that belongs to other colour variants
   - LCP-safe: does not force base URL to variant media
   - Reflow-safe: avoids layout reads immediately after display/class writes
   - Dots: no offsetLeft reads during scroll; cached in rAF
   ====================================================================== */
(function () {
  "use strict";

  function key(u) {
    try {
      var x = new URL(u, location.origin);
      return x.pathname.split("/").pop();
    } catch (e) {
      return (u || "").split("?")[0].split("/").pop();
    }
  }

  function urlHasVariant() {
    try {
      return new URLSearchParams(location.search).has("variant");
    } catch (e) {
      return /\bvariant=\d+\b/.test(location.search);
    }
  }

  function getVariantIdFromUrl() {
    try {
      return new URLSearchParams(location.search).get("variant");
    } catch (e) {
      var m = location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }
  }

  function extractBareId(maybe) {
    var s = String(maybe || "");
    if (!s) return "";
    var m = s.match(/(\d+)\s*$/);
    return m ? m[1] : s;
  }

  function idMatches(a, bareId) {
    if (!a || !bareId) return false;
    var s = String(a);
    var b = String(bareId);
    return s === b || extractBareId(s) === b || s.slice(-1 - b.length) === "-" + b;
  }

  function dispatchClicks(el) {
    if (!el) return;

    try {
      el.dispatchEvent(new PointerEvent("pointerdown", { bubbles: true }));
      el.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
      el.dispatchEvent(new MouseEvent("mouseup", { bubbles: true }));
      el.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
    } catch (e) {
      if (el.click) el.click();
    }
  }

  function clickThumb(li) {
    if (!li) return;
    var btn = li.querySelector("button, a, [role='button']") || li;
    dispatchClicks(btn);
  }

  function getActiveThumb(section) {
    var el = section.querySelector(".thumbnail-list__item [aria-current='true']");
    if (el) return el.closest(".thumbnail-list__item");

    return section.querySelector(".thumbnail-list__item.is-active");
  }

  function isVisibleThumb(li) {
    if (!li) return false;
    if (li.getAttribute("data-scrubme-hidden") === "1") return false;
    if (li.style && li.style.display === "none") return false;

    return true;
  }

  function firstVisibleThumb(section, root) {
    var items = (root || section).querySelectorAll(".thumbnail-list__item");

    for (var i = 0; i < items.length; i++) {
      if (isVisibleThumb(items[i])) return items[i];
    }

    for (var j = 0; j < items.length; j++) {
      if (items[j] && items[j].style.display !== "none") return items[j];
    }

    return null;
  }

  function setVisible(el, show) {
    if (!el) return;

    var desired = show ? "" : "none";

    if (el.style.display !== desired) {
      el.style.display = desired;
    }
  }

  function setThumbHiddenFlag(li, hidden) {
    if (!li) return;

    if (hidden) {
      li.setAttribute("data-scrubme-hidden", "1");
    } else {
      li.removeAttribute("data-scrubme-hidden");
    }
  }

  function clearLegacyThumbHiding(section) {
    if (!section) return;

    var els = section.querySelectorAll(".scrubme-thumbs-hidden");

    for (var i = 0; i < els.length; i++) {
      els[i].classList.remove("scrubme-thumbs-hidden");
    }
  }

  function getGalleryRoots(section) {
    var galleryList = section.querySelector('[id^="Slider-Gallery-"]');
    var thumbList = section.querySelector('[id^="Slider-Thumbnails-"]');

    return {
      galleryList: galleryList,
      thumbList: thumbList
    };
  }

  function refreshThumbnailSlider(section) {
    var sc = section.querySelector('slider-component[id^="GalleryThumbnails-"]');
    if (!sc) return;

    var list = sc.querySelector(".thumbnail-list");
    var prev = sc.querySelector(".slider-button--prev");
    var next = sc.querySelector(".slider-button--next");

    if (!list || !prev || !next) return;

    function measureMaxScroll() {
      return Math.max(0, list.scrollWidth - list.clientWidth);
    }

    function updateArrows(forceMeasure) {
      var maxScroll = list.__scrubmeMaxScroll;

      if (forceMeasure || maxScroll == null) {
        maxScroll = measureMaxScroll();
        list.__scrubmeMaxScroll = maxScroll;
      }

      var atStart = list.scrollLeft <= 1;
      var atEnd = maxScroll - list.scrollLeft <= 1;

      prev.removeAttribute("aria-hidden");
      next.removeAttribute("aria-hidden");

      if (atStart) {
        prev.setAttribute("disabled", "disabled");
      } else {
        prev.removeAttribute("disabled");
      }

      if (atEnd) {
        next.setAttribute("disabled", "disabled");
      } else {
        next.removeAttribute("disabled");
      }
    }

    if (!sc.__scrubmeBound) {
      sc.__scrubmeBound = true;

      var scrollScheduled = false;

      list.addEventListener(
        "scroll",
        function () {
          if (scrollScheduled) return;

          scrollScheduled = true;

          requestAnimationFrame(function () {
            scrollScheduled = false;
            updateArrows(false);
          });
        },
        { passive: true }
      );

      if ("ResizeObserver" in window) {
        var ro = new ResizeObserver(function () {
          list.__scrubmeMaxScroll = null;

          requestAnimationFrame(function () {
            updateArrows(true);
          });
        });

        ro.observe(list);
        sc.__scrubmeRO = ro;
      } else {
        var resizeScheduled = false;

        window.addEventListener("resize", function () {
          if (resizeScheduled) return;

          resizeScheduled = true;

          requestAnimationFrame(function () {
            resizeScheduled = false;
            list.__scrubmeMaxScroll = null;
            updateArrows(true);
          });
        });
      }
    }

    requestAnimationFrame(function () {
      list.__scrubmeMaxScroll = null;
      updateArrows(true);
    });
  }

  function findColorOptionIndex(options) {
    if (!Array.isArray(options)) return 0;

    for (var i = 0; i < options.length; i++) {
      var n = options[i];
      if (!n) continue;

      var s = ("" + n).toLowerCase();

      if (s.indexOf("colour") !== -1 || s.indexOf("color") !== -1) return i;
    }

    return 0;
  }

  function valuesForOptionIndex(variants, idx) {
    var set = {};
    var out = [];

    (variants || []).forEach(function (v) {
      var val = v && v["option" + (idx + 1)];
      if (!val) return;

      val = String(val).trim();

      if (!val || set[val]) return;

      set[val] = 1;
      out.push(val);
    });

    return out;
  }

  function altHasLower(altLower, tLower) {
    return !!(altLower && tLower) && altLower.indexOf(tLower) !== -1;
  }

  function countColourMatches(altLower, allValuesLower) {
    var count = 0;

    if (!altLower || !allValuesLower || !allValuesLower.length) return count;

    for (var i = 0; i < allValuesLower.length; i++) {
      if (allValuesLower[i] && altLower.indexOf(allValuesLower[i]) !== -1) {
        count++;
      }
    }

    return count;
  }

  function hasOtherColourMatch(altLower, selectedLower, allValuesLower) {
    if (!altLower || !allValuesLower || !allValuesLower.length) return false;

    for (var i = 0; i < allValuesLower.length; i++) {
      var value = allValuesLower[i];

      if (!value || value === selectedLower) continue;

      if (altLower.indexOf(value) !== -1) {
        return true;
      }
    }

    return false;
  }

  function isGenericLower(altLower, allValuesLower) {
    if (!altLower) return true;

    for (var i = 0; i < allValuesLower.length; i++) {
      if (altLower.indexOf(allValuesLower[i]) !== -1) return false;
    }

    return true;
  }

  function thumbForMediaId(section, bareId) {
    if (!bareId) return null;

    var items = section.querySelectorAll(".thumbnail-list__item");

    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (!li) continue;

      var t =
        li.getAttribute("data-target") ||
        li.getAttribute("data-media-id") ||
        (li.dataset ? li.dataset.mediaId : "") ||
        "";

      if (idMatches(t, bareId)) return li;
    }

    return null;
  }

  function resetAllVisible(section) {
    var roots = getGalleryRoots(section);
    var galleryList = roots.galleryList;
    var thumbList = roots.thumbList;

    var slides = galleryList ? galleryList.querySelectorAll(".product__media-item") : [];

    for (var s = 0; s < slides.length; s++) {
      setVisible(slides[s], true);
    }

    var thumbs = thumbList
      ? thumbList.querySelectorAll(".thumbnail-list__item")
      : section.querySelectorAll(".thumbnail-list__item");

    for (var t = 0; t < thumbs.length; t++) {
      setVisible(thumbs[t], true);
      setThumbHiddenFlag(thumbs[t], false);
    }
  }

  function refreshViewer(section, thumbList, preferLi, doActivate, forceVariantHero) {
    var root = thumbList || section;

    if (!doActivate && !forceVariantHero) {
      var current = getActiveThumb(section);

      if (current && isVisibleThumb(current)) {
        return;
      }

      var target0 = preferLi && isVisibleThumb(preferLi) ? preferLi : firstVisibleThumb(section, root);
      if (!target0) return;

      var b0 = target0.querySelector("button, a, [role='button']");

      if (b0 && b0.getAttribute("aria-current") !== "true") {
        b0.setAttribute("aria-current", "true");
      }

      if (!target0.classList.contains("is-active")) {
        target0.classList.add("is-active");
      }

      return;
    }

    var currentButtons = root.querySelectorAll('.thumbnail-list__item [aria-current="true"]');

    for (var i = 0; i < currentButtons.length; i++) {
      currentButtons[i].removeAttribute("aria-current");
    }

    var actives = root.querySelectorAll(".thumbnail-list__item.is-active");

    for (var j = 0; j < actives.length; j++) {
      actives[j].classList.remove("is-active");
    }

    var target = preferLi && isVisibleThumb(preferLi) ? preferLi : firstVisibleThumb(section, root);

    if (target) {
      var b = target.querySelector("button, a, [role='button']");

      if (b) {
        b.setAttribute("aria-current", "true");
      }

      target.classList.add("is-active");
      clickThumb(target);
    }
  }

  function applyVariantFilter(section, cfg, opts) {
    opts = opts || {};

    var doActivate = !!opts.activate;
    var forceVariantHero = !!opts.forceVariantHero;

    if (!urlHasVariant()) {
      resetAllVisible(section);

      return {
        didFilter: false,
        doActivate: doActivate,
        forceVariantHero: false,
        prefer: null
      };
    }

    var id = getVariantIdFromUrl();

    if (!id) {
      return {
        didFilter: false,
        doActivate: doActivate,
        forceVariantHero: false,
        prefer: null
      };
    }

    var variants = Array.isArray(cfg.variants) ? cfg.variants : [];
    var selVar = null;

    for (var vi = 0; vi < variants.length; vi++) {
      if (String(variants[vi].id) === String(id)) {
        selVar = variants[vi];
        break;
      }
    }

    if (!selVar) {
      return {
        didFilter: false,
        doActivate: doActivate,
        forceVariantHero: false,
        prefer: null
      };
    }

    var options = Array.isArray(cfg.options) ? cfg.options : [];

    var heroKey = key(cfg.heroSrc || "");
    var heroBareId = extractBareId(cfg.heroId != null ? String(cfg.heroId) : "");

    var selectedFeaturedBareId = selVar.featured_media && selVar.featured_media.id ? String(selVar.featured_media.id) : "";

    var optIdx = findColorOptionIndex(options);
    var keyName = "option" + (optIdx + 1);
    var selectedValue = String(selVar[keyName] || "").trim();
    var selectedLower = selectedValue.toLowerCase();

    var allValues = valuesForOptionIndex(variants, optIdx);
    var allValuesLower = [];

    for (var ai = 0; ai < allValues.length; ai++) {
      allValuesLower.push(String(allValues[ai]).toLowerCase());
    }

    var activeThumb = getActiveThumb(section);
    var activeMediaToken = "";

    if (activeThumb) {
      activeMediaToken =
        activeThumb.getAttribute("data-target") ||
        activeThumb.getAttribute("data-media-id") ||
        (activeThumb.dataset ? activeThumb.dataset.mediaId : "") ||
        "";
    }

    var activeBareId = extractBareId(activeMediaToken);

    function isThisActiveMedia(token) {
      if (forceVariantHero) return false;
      if (!activeMediaToken && !activeBareId) return false;

      return idMatches(token, activeBareId) || String(token) === String(activeMediaToken);
    }

    function shouldShowVariantMedia(args) {
      var token = args.token || "";
      var altLower = args.altLower || "";
      var srcKey = args.srcKey || "";

      var isHero = (heroBareId && idMatches(token, heroBareId)) || (heroKey && srcKey === heroKey);
      var isSelectedFeatured = selectedFeaturedBareId && idMatches(token, selectedFeaturedBareId);

      var matchesSelectedColour = altHasLower(altLower, selectedLower);
      var matchesOtherColour = hasOtherColourMatch(altLower, selectedLower, allValuesLower);
      var colourMatchCount = countColourMatches(altLower, allValuesLower);
      var isGeneric = isGenericLower(altLower, allValuesLower);

      /*
        Important ScrubMe behaviour:
        - On the base URL, the product hero is allowed.
        - Once a variant URL exists, the old product hero must not remain as slide 2.
        - This hides the base product hero after variant selection when cfg.heroSrc/cfg.heroId
          still point to the base product hero from the original page load.
      */
      var hideOldProductHero = isHero && !isSelectedFeatured;

      /*
        If an image alt contains the selected colour AND another colour, it is normally
        the main mixed-colour product hero. Hide it on variant URLs.
      */
      var hideMixedColourHero = matchesSelectedColour && matchesOtherColour && colourMatchCount > 1;

      if (isSelectedFeatured) return true;
      if (hideOldProductHero) return false;
      if (hideMixedColourHero) return false;

      return matchesSelectedColour || isGeneric;
    }

    var roots = getGalleryRoots(section);
    var galleryList = roots.galleryList;
    var thumbList = roots.thumbList;

    var slides = galleryList ? galleryList.querySelectorAll(".product__media-item") : [];
    var thumbs = thumbList
      ? thumbList.querySelectorAll(".thumbnail-list__item")
      : section.querySelectorAll(".thumbnail-list__item");

    for (var s = 0; s < slides.length; s++) {
      var slide = slides[s];
      if (!slide) continue;

      var slideToken = slide.getAttribute("data-media-id") || (slide.dataset ? slide.dataset.mediaId : "") || "";
      slideToken = String(slideToken || "");

      if (!doActivate && isThisActiveMedia(slideToken)) {
        setVisible(slide, true);
        continue;
      }

      var img = slide.querySelector("img");

      if (!img) {
        setVisible(slide, true);
        continue;
      }

      var alt = (img.getAttribute("alt") || "").toLowerCase();
      var srcK = key(img.getAttribute("src") || img.currentSrc || "");

      var show = shouldShowVariantMedia({
        token: slideToken,
        altLower: alt,
        srcKey: srcK
      });

      setVisible(slide, show);
    }

    for (var t = 0; t < thumbs.length; t++) {
      var li = thumbs[t];
      if (!li) continue;

      var img2 = li.querySelector("img");
      if (!img2) continue;

      var tok =
        li.getAttribute("data-target") ||
        li.getAttribute("data-media-id") ||
        (li.dataset ? li.dataset.mediaId : "") ||
        "";

      tok = String(tok || "");

      if (!doActivate && isThisActiveMedia(tok)) {
        setVisible(li, true);
        setThumbHiddenFlag(li, false);
        continue;
      }

      var alt2 = (img2.getAttribute("alt") || "").toLowerCase();
      var srcK2 = key(img2.getAttribute("src") || img2.currentSrc || "");

      var show2 = shouldShowVariantMedia({
        token: tok,
        altLower: alt2,
        srcKey: srcK2
      });

      setVisible(li, show2);
      setThumbHiddenFlag(li, !show2);
    }

    var prefer = selectedFeaturedBareId ? thumbForMediaId(section, selectedFeaturedBareId) : null;

    if (prefer && prefer.style.display === "none") {
      prefer = null;
    }

    return {
      didFilter: true,
      doActivate: doActivate,
      forceVariantHero: forceVariantHero,
      prefer: prefer
    };
  }

  function initOne(cfg) {
    if (!cfg || !cfg.sectionId) return;

    var section = document.querySelector("#shopify-section-" + cfg.sectionId);
    if (!section) return;

    var state = {
      interacted: false,
      initialVariantUrl: urlHasVariant(),
      initialVariantHandled: false
    };

    function markInteracted() {
      state.interacted = true;
    }

    section.addEventListener("pointerdown", markInteracted, true);
    section.addEventListener("touchstart", markInteracted, { passive: true, capture: true });

    section.addEventListener(
      "keydown",
      function (e) {
        if (!e) return;

        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          markInteracted();
        }
      },
      true
    );

    section.addEventListener(
      "change",
      function (e) {
        if (!e || !e.target) return;

        var t = e.target;

        if (t.matches('input[name^="options"]') || t.matches('select[name^="options"]')) {
          markInteracted();
        }
      },
      true
    );

    var scheduled = false;

    function scheduleRun() {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;

        var roots = getGalleryRoots(section);
        var thumbList = roots.thumbList;

        var forceVariantHero = state.initialVariantUrl && urlHasVariant() && !state.initialVariantHandled;

        var res = applyVariantFilter(section, cfg, {
          activate: state.interacted || forceVariantHero,
          forceVariantHero: forceVariantHero
        });

        clearLegacyThumbHiding(section);

        requestAnimationFrame(function () {
          if (!res) return;

          if (!urlHasVariant()) {
            state.initialVariantHandled = true;

            refreshThumbnailSlider(section);

            document.dispatchEvent(
              new CustomEvent("scrubme:variantMediaFiltered", {
                detail: {
                  section: section
                }
              })
            );

            return;
          }

          refreshViewer(section, thumbList, res.prefer, res.doActivate, res.forceVariantHero);

          if (forceVariantHero) {
            state.initialVariantHandled = true;
          }

          refreshThumbnailSlider(section);

          document.dispatchEvent(
            new CustomEvent("scrubme:variantMediaFiltered", {
              detail: {
                section: section
              }
            })
          );
        });
      });
    }

    scheduleRun();

    document.addEventListener("variant:change", scheduleRun);
    document.addEventListener("variant:changed", scheduleRun);
    document.addEventListener("product:variant-change", scheduleRun);

    window.ScrubMeMainVariantHub = window.ScrubMeMainVariantHub || {
      patched: false,
      listeners: []
    };

    window.ScrubMeMainVariantHub.listeners.push(scheduleRun);

    if (!window.ScrubMeMainVariantHub.patched) {
      window.ScrubMeMainVariantHub.patched = true;

      var ps = history.pushState;
      var rs = history.replaceState;

      function fireSoon() {
        setTimeout(function () {
          var ls = window.ScrubMeMainVariantHub.listeners || [];

          for (var i = 0; i < ls.length; i++) {
            try {
              ls[i]();
            } catch (e) {}
          }
        }, 0);
      }

      if (ps) {
        history.pushState = function () {
          ps.apply(this, arguments);
          fireSoon();
        };
      }

      if (rs) {
        history.replaceState = function () {
          rs.apply(this, arguments);
          fireSoon();
        };
      }

      window.addEventListener("popstate", fireSoon);
    }
  }

  window.scrubmeMainVariantInit = initOne;
})();

/* ======================================================================
   ScrubMe — Mobile pagination dots
   - caches slide left positions in rAF
   - scroll handler uses cached array only
   ====================================================================== */
(function () {
  "use strict";

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function visibleSlides(list) {
    var all = list ? list.querySelectorAll(".slider__slide") : [];

    return Array.prototype.filter.call(all, function (li) {
      return li && li.style.display !== "none";
    });
  }

  function binaryClosestIndex(lefts, x) {
    if (!lefts || !lefts.length) return 0;

    var lo = 0;
    var hi = lefts.length - 1;

    while (lo < hi) {
      var mid = (lo + hi) >> 1;

      if (lefts[mid] < x) {
        lo = mid + 1;
      } else {
        hi = mid;
      }
    }

    var a = lo;
    var b = Math.max(0, lo - 1);

    if (Math.abs(lefts[b] - x) <= Math.abs(lefts[a] - x)) return b;

    return a;
  }

  function computeWindow(total, current, maxDots) {
    if (total <= maxDots) {
      var arr = new Array(total);

      for (var i = 0; i < total; i++) {
        arr[i] = i;
      }

      return {
        indexes: arr,
        start: 0
      };
    }

    var start;

    if (current <= 4) {
      start = 0;
    } else if (current >= total - 1) {
      start = total - maxDots;
    } else {
      start = current - 4;

      if (start < 0) start = 0;
      if (start > total - maxDots) start = total - maxDots;
    }

    var out = [];

    for (var k = 0; k < maxDots; k++) {
      out.push(start + k);
    }

    return {
      indexes: out,
      start: start
    };
  }

  function renderDots(container, list) {
    var slides = container.__scrubmeDotsSlides || [];
    var lefts = container.__scrubmeDotsLefts || [];

    if (!slides.length || slides.length <= 1 || lefts.length !== slides.length) {
      container.innerHTML = "";
      return;
    }

    var maxDots = 6;
    var scrollLeft = list.scrollLeft || 0;

    var current = binaryClosestIndex(lefts, scrollLeft);
    var winObj = computeWindow(slides.length, current, maxDots);
    var win = winObj.indexes;
    var start = winObj.start;

    var now = Array.prototype.map.call(container.querySelectorAll(".scrubme-dots__dot"), function (d) {
      return +d.dataset.slideIndex;
    });

    var changed =
      now.length !== win.length ||
      win.some(function (v, i) {
        return v !== now[i];
      });

    if (changed) {
      container.innerHTML = "";

      for (var i = 0; i < win.length; i++) {
        (function (idxInner) {
          var b = document.createElement("button");

          b.type = "button";
          b.className = "scrubme-dots__dot";
          b.setAttribute("aria-label", "Go to slide " + (idxInner + 1));
          b.dataset.slideIndex = String(idxInner);

          b.addEventListener("click", function (ev) {
            var to = +ev.currentTarget.dataset.slideIndex;
            var leftsLocal = container.__scrubmeDotsLefts || [];
            var targetLeft = leftsLocal[to] != null ? leftsLocal[to] : 0;

            try {
              list.scrollTo({
                left: targetLeft,
                behavior: "smooth"
              });
            } catch (e) {
              list.scrollLeft = targetLeft;
            }
          });

          container.appendChild(b);
        })(win[i]);
      }
    }

    var visualActiveIndex = Math.min(current - start, maxDots - 1);
    var dots = container.querySelectorAll(".scrubme-dots__dot");

    for (var d2 = 0; d2 < dots.length; d2++) {
      if (d2 === visualActiveIndex) {
        dots[d2].setAttribute("aria-current", "true");
      } else {
        dots[d2].removeAttribute("aria-current");
      }
    }
  }

  function scheduleCache(container, list) {
    if (!container || !list) return;

    if (container.__scrubmeDotsCacheRAF) return;

    container.__scrubmeDotsCacheRAF = requestAnimationFrame(function () {
      container.__scrubmeDotsCacheRAF = 0;

      var slides = visibleSlides(list);

      container.__scrubmeDotsSlides = slides;

      if (slides.length <= 1) {
        container.innerHTML = "";
        container.__scrubmeDotsLefts = [];
        return;
      }

      var lefts = [];

      for (var i = 0; i < slides.length; i++) {
        lefts.push(slides[i].offsetLeft);
      }

      container.__scrubmeDotsLefts = lefts;

      renderDots(container, list);
    });
  }

  function buildDots(container) {
    if (!container) return;

    if (!isMobile()) {
      container.style.display = "none";
      return;
    }

    container.style.display = "";

    var targetId = container.getAttribute("data-target");
    var list = document.getElementById(targetId);

    if (!list) return;

    scheduleCache(container, list);

    if (!container.__scrubmeDotsBound) {
      container.__scrubmeDotsBound = true;

      var scrollScheduled = false;

      list.addEventListener(
        "scroll",
        function () {
          if (scrollScheduled) return;

          scrollScheduled = true;

          requestAnimationFrame(function () {
            scrollScheduled = false;
            renderDots(container, list);
          });
        },
        { passive: true }
      );

      if ("ResizeObserver" in window) {
        var ro = new ResizeObserver(function () {
          scheduleCache(container, list);
        });

        ro.observe(list);
        container.__scrubmeDotsRO = ro;
      } else {
        var resizeScheduled = false;

        window.addEventListener("resize", function () {
          if (resizeScheduled) return;

          resizeScheduled = true;

          requestAnimationFrame(function () {
            resizeScheduled = false;
            scheduleCache(container, list);
          });
        });
      }

      if ("MutationObserver" in window) {
        var mo = new MutationObserver(function () {
          clearTimeout(container.__scrubmeDotsDeb);

          container.__scrubmeDotsDeb = setTimeout(function () {
            scheduleCache(container, list);
          }, 60);
        });

        mo.observe(list, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"]
        });

        container.__scrubmeDotsMO = mo;
      }

      document.addEventListener("scrubme:variantMediaFiltered", function () {
        scheduleCache(container, list);
      });

      var rebuild = function () {
        setTimeout(function () {
          buildDots(container);
        }, 0);
      };

      document.addEventListener("variant:change", rebuild);
      document.addEventListener("variant:changed", rebuild);
      document.addEventListener("product:variant-change", rebuild);
      window.addEventListener("popstate", rebuild);
    }
  }

  function initAllDots() {
    var nodes = document.querySelectorAll('[id^="GalleryDots-"].scrubme-dots[data-target]');

    for (var i = 0; i < nodes.length; i++) {
      buildDots(nodes[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllDots);
  } else {
    initAllDots();
  }

  document.addEventListener("shopify:section:load", initAllDots);
})();